import Marquee from "react-fast-marquee";

const ITEMS = [
  "Kronegekkoer",
  "Premium Morfer",
  "Håndlavede Terrarier",
  "Gekko Foder",
  "Bioaktiv Jord",
  "Opdrættet i Danmark",
];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-white/10 bg-moss py-7"
    >
      <Marquee speed={28} gradient={false}>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="mx-10 font-serif text-2xl italic text-pale/75 lg:text-3xl">
              {item}
            </span>
            <span className="inline-block h-2 w-2 rotate-45 bg-forest/80" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
